// src/contexts/ModalContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    open: false,
    title: '',
    message: '',
    type: 'info',
    confirmText: 'OK',
    cancelText: 'Fechar',
    showCancel: false,
    onConfirm: null,
  });

  const showModal = useCallback((options = {}) => {
    setModal({
      open: true,
      title: options.title || '',
      message: options.message || '',
      type: options.type || 'info',
      confirmText: options.confirmText || 'OK',
      cancelText: options.cancelText || 'Fechar',
      showCancel: !!options.showCancel,
      onConfirm: options.onConfirm || null,
    });
  }, []);

  const hideModal = useCallback(() => {
    setModal((m) => ({ ...m, open: false }));
  }, []);

  const handleConfirm = useCallback(() => {
    if (typeof modal.onConfirm === 'function') {
      try {
        modal.onConfirm();
      } catch (err) {
        console.error('Erro em onConfirm do modal:', err);
      }
    }
    hideModal();
  }, [modal.onConfirm, hideModal]);

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Modal
        open={modal.open}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        confirmText={modal.confirmText}
        cancelText={modal.cancelText}
        showCancel={modal.showCancel}
        onClose={hideModal}
        onConfirm={handleConfirm}
      />
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('useModal must be used within a ModalProvider');
  return ctx;
};
